/*
 * @Author: 张斌
 * @Date: 2023-10-25 14:57:49
 * @LastEditors: 张斌
 * @LastEditTime: 2024-08-13 18:20:30
 */
import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'
import '@/styles/index.scss'
import '@/icons/components'
import '@/permission'

import 'element-ui/lib/theme-chalk/index.css';
/**
 * This project originally used easy-mock to simulate data requests,
 * but its official service is not stable.
 * So here We use Mock.js for a local emulation,
 * it will intercept your request and you won't see the request in the network.
 * If you remove `import '../mock'` it will automatically request easy-mock data.
 */
import '../mock' // simulation data requests

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/registerServiceWorker'
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.use(ElementUI)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em',
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
